module.exports = __webpack_public_path__ + "media/src/assets/Images/Facebook-c602f8dbf288431459f9f52fb894d533.svg";